import React from "react";

export default function FooterBar() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div className="container">
        <p>
          © {currentYear} SUMABIT, todos los derechos reservados. Power by{" "}
          <a
            href="https://www.pifold.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            PIFOLD
          </a>
          .
        </p>
      </div>
    </footer>
  );
}
